export const navList: any = [
    // {
    //     name: 'Dashboard',
    //     path: '/dashboard-v2',
    //     icon: 'ic_logo-old',
    //     isNew: true,
    //     key: 'dashboard',
    //     show: ['all']
    // },
    {
        name: 'Dashboard',
        path: '/dashboard-v3',
        icon: 'ic_visit',
        key: 'dashboard',
        show: ['all']
    },
    {
        name: 'My Profile',
        path: '/agent/',
        icon: 'ic_profile',
        key: 'profile',
        show: [
            'EditSelfDefaulters',
            'AssignIntraOrg',
            'EditOrgDefaulters',
            'AssignInterOrg',
            'EditGlobalDefaulters',
            'Admin']
    },
    {
        name: 'Agency Profile',
        path: '/agency/',
        icon: 'ic_office',
        key: 'agency',
        show: [
            'EditSelfDefaulters',
            'AssignIntraOrg',
            'EditOrgDefaulters',
            'AssignInterOrg',
            'EditGlobalDefaulters',
            'Admin']
    },
    {
        name: 'Accounts',
        path: '/accounts',
        icon: 'ic_grow-up',
        key: 'accounts',
        show: ['all']
    },
    {
        name: 'Bureau Reports',
        path: '/bureauReports',
        icon: 'ic_file-pdf',
        key: 'accounts',
        show: ['Admin']
    },
    {
        name: 'Payments',
        path: '/payments',
        icon: 'ic_wallet-outline',
        key: 'payments',
        show: ['all']
    },
    {
        name: 'Import',
        path: '/importData',
        icon: 'ic_upload',
        key: 'dataImport',
        show: [
            'AssignIntraOrg',
            'EditOrgDefaulters',
            'AssignInterOrg',
            'EditGlobalDefaulters',
            'Admin']
    },
    // {
    //     name: 'Agencies',
    //     path: '/viewAgencies',
    //     icon: 'ic_settings',
    //     key: 'agencies',
    //     show: [
    //         'EditOrgDefaulters',
    //         'AssignInterOrg',
    //         'EditGlobalDefaulters',
    //         'Admin']
    // },
    // {
    //     name: 'Team Members',
    //     path: '/viewAgents',
    //     icon: 'ic_question-outline',
    //     key: 'agents',
    //     show: [
    //         'EditSelfDefaulters',
    //         'AssignIntraOrg',
    //         'EditOrgDefaulters',
    //         'AssignInterOrg',
    //         'EditGlobalDefaulters',
    //         'Admin']
    // },
    {
        name: 'Allocate Cases',
        path: '/allocations',
        icon: 'ic_action',
        key: 'allocation',
        show: [
            'AssignIntraOrg',
            'EditOrgDefaulters',
            'AssignInterOrg',
            'EditGlobalDefaulters',
            'Admin']
    },
    {
        name: 'Rule Engine',
        path: '/ruleEngine',
        icon: 'ic_settings',
        key: 'ruleEngine',
        show: ['Admin']
    },
    {
        name: 'Offers',
        path: '/offers',
        icon: 'ic_notification-outline',
        key: 'allOffers',
        show: ['Admin', 'EditGlobalDefaulters']
    },
    // {   name: 'Rule Engine',
    //     path: '/new-ruleEngine',
    //     icon: 'ic_settings',
    //     key: 'ruleEnginev2',
    //     show: ['Admin']
    // },
    {
        name: "Organizations",
        path: '/organizations',
        icon: 'ic_settings',
        key: 'organizations',
        show: [
            'AssignIntraOrg',
            'EditOrgDefaulters',
            'AssignInterOrg',
            'EditGlobalDefaulters',
            'Admin']
    },
    // {
    //     name: 'Subscriptions',
    //     path: '/subscriptions',
    //     icon: 'ic_crown',
    //     key: 'subscriptions',
    //     show: ['Admin']
    // },
]
